// src/constants/resources.constant.ts
var RESOURCES = {
  PRODUCTS: "products",
  USERS: "users",
  ORDERS: "orders",
  SUPPLIERS: "suppliers"
};

// src/enums/discount-type.enum.ts
var DiscountType = /* @__PURE__ */ ((DiscountType2) => {
  DiscountType2["Percentage"] = "percentage";
  DiscountType2["Fixed"] = "fixed";
  return DiscountType2;
})(DiscountType || {});

// src/enums/customer-type.enum.ts
var CustomerType = /* @__PURE__ */ ((CustomerType2) => {
  CustomerType2["WHOLESALE"] = "wholesale";
  CustomerType2["RETAIL"] = "retail";
  CustomerType2["WALKIN"] = "walk-in";
  return CustomerType2;
})(CustomerType || {});

// src/enums/inventory-transaction-status.enum.ts
var InventoryTransactionStatus = /* @__PURE__ */ ((InventoryTransactionStatus2) => {
  InventoryTransactionStatus2["CART"] = "cart";
  InventoryTransactionStatus2["PURCHASED"] = "purchased";
  InventoryTransactionStatus2["CANCELLED"] = "cancelled";
  InventoryTransactionStatus2["RETURNED"] = "returned";
  InventoryTransactionStatus2["SOLD"] = "sold";
  InventoryTransactionStatus2["ADJUSTED"] = "adjusted";
  return InventoryTransactionStatus2;
})(InventoryTransactionStatus || {});

// src/enums/inventory-transaction-type.enum.ts
var InventoryTransactionType = /* @__PURE__ */ ((InventoryTransactionType2) => {
  InventoryTransactionType2["IN"] = "in";
  InventoryTransactionType2["OUT"] = "out";
  InventoryTransactionType2["ADJUSTMENT"] = "adjustment";
  InventoryTransactionType2["AdjustmentExpired"] = "adjustment_expired";
  InventoryTransactionType2["RETURN"] = "return";
  return InventoryTransactionType2;
})(InventoryTransactionType || {});

// src/enums/order-type.enum.ts
var OrderType = /* @__PURE__ */ ((OrderType2) => {
  OrderType2["RETAIL"] = "retail";
  OrderType2["WHOLESALE"] = "wholesale";
  return OrderType2;
})(OrderType || {});

// src/enums/payment-status.enum.ts
var PaymentStatus = /* @__PURE__ */ ((PaymentStatus2) => {
  PaymentStatus2["DUE"] = "due";
  PaymentStatus2["PAID"] = "paid";
  return PaymentStatus2;
})(PaymentStatus || {});
var PaymentType = /* @__PURE__ */ ((PaymentType2) => {
  PaymentType2["PURCHASE"] = "purchase";
  PaymentType2["REFUND"] = "refund";
  PaymentType2["SALE"] = "sale";
  PaymentType2["ADJUSTMENT"] = "adjustment";
  return PaymentType2;
})(PaymentType || {});

// src/enums/permission-type.enum.ts
var PermissionType = /* @__PURE__ */ ((PermissionType2) => {
  PermissionType2["Read"] = "read";
  PermissionType2["Create"] = "create";
  PermissionType2["Update"] = "update";
  PermissionType2["Delete"] = "delete";
  return PermissionType2;
})(PermissionType || {});

// src/enums/resource.enum.ts
var Resource = /* @__PURE__ */ ((Resource2) => {
  Resource2["CART"] = "cart";
  Resource2["CUSTOMERS"] = "customers";
  Resource2["DISCOUNT"] = "discount";
  Resource2["USERS"] = "users";
  Resource2["INVENTORY"] = "inventory";
  Resource2["INVOICE"] = "invoice";
  Resource2["ORDERS"] = "orders";
  Resource2["PAYMENTS"] = "payments";
  Resource2["PRODUCTS"] = "products";
  Resource2["PURCHASES"] = "purchases";
  Resource2["SUPPLIERS"] = "suppliers";
  Resource2["REPORTS"] = "reports";
  Resource2["ADJUSTMENT"] = "adjustment";
  Resource2["WHOLESALE"] = "wholesale";
  Resource2["SETTINGS"] = "settings";
  Resource2["RETURN"] = "return";
  Resource2["EXPENSE"] = "expense";
  return Resource2;
})(Resource || {});

// src/enums/sort-type.enum.ts
var SortOrderType = /* @__PURE__ */ ((SortOrderType2) => {
  SortOrderType2["ASC"] = "asc";
  SortOrderType2["DESC"] = "desc";
  return SortOrderType2;
})(SortOrderType || {});

// src/enums/db-types.enum.ts
var ItemPriceType = /* @__PURE__ */ ((ItemPriceType2) => {
  ItemPriceType2["WHOLESALE"] = "wholesale";
  ItemPriceType2["RETAIL"] = "retail";
  ItemPriceType2["PURCHASE"] = "purchase";
  return ItemPriceType2;
})(ItemPriceType || {});
var CustomerAccountType = /* @__PURE__ */ ((CustomerAccountType2) => {
  CustomerAccountType2["REGULAR"] = "regular";
  CustomerAccountType2["WHOLESALE"] = "wholesale";
  return CustomerAccountType2;
})(CustomerAccountType || {});
var PaymentTransactionType = /* @__PURE__ */ ((PaymentTransactionType2) => {
  PaymentTransactionType2["PURCHASE"] = "purchase";
  PaymentTransactionType2["SALE"] = "sale";
  PaymentTransactionType2["ADJUSTMENT"] = "adjustment";
  return PaymentTransactionType2;
})(PaymentTransactionType || {});
var PurchaseStatus = /* @__PURE__ */ ((PurchaseStatus2) => {
  PurchaseStatus2["PENDING"] = "pending";
  PurchaseStatus2["COMPLETED"] = "completed";
  PurchaseStatus2["CANCELLED"] = "cancelled";
  return PurchaseStatus2;
})(PurchaseStatus || {});
var DiscountStatus = /* @__PURE__ */ ((DiscountStatus2) => {
  DiscountStatus2["ACTIVE"] = "active";
  DiscountStatus2["INACTIVE"] = "inactive";
  return DiscountStatus2;
})(DiscountStatus || {});

// src/enums/payment-method.enum.ts
var PaymentMethod = /* @__PURE__ */ ((PaymentMethod2) => {
  PaymentMethod2["CASH"] = "CASH";
  PaymentMethod2["BANK"] = "BANK";
  PaymentMethod2["MobileBankingBkash"] = "MOBILE_BANKING_BKASH";
  PaymentMethod2["MobileBankingRocket"] = "MOBILE_BANKING_ROCKET";
  PaymentMethod2["MobileBankingNagad"] = "MOBILE_BANKING_NAGAD";
  return PaymentMethod2;
})(PaymentMethod || {});
export {
  CustomerAccountType,
  CustomerType,
  DiscountStatus,
  DiscountType,
  InventoryTransactionStatus,
  InventoryTransactionType,
  ItemPriceType,
  OrderType,
  PaymentMethod,
  PaymentStatus,
  PaymentTransactionType,
  PaymentType,
  PermissionType,
  PurchaseStatus,
  RESOURCES,
  Resource,
  SortOrderType
};
